import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    '@media screen and (max-width: 700px)': {
      root: {
        maxWidth: 280,
      },
    },
    root: {
      position: 'relative',
      minHeight: 146,
      height: 341,
      width: 272,
      display: 'flex',
      flexFlow: 'column nowrap',
      padding: theme.spacing(1.5),
      borderRadius: theme.shape.borderRadius,
      background: 'white',
      border: '1px solid',
      borderColor: COLORS.gray.gray60,
      boxShadow: 'none',
      cursor: 'pointer',
      overflow: 'hidden',

      '&:not($disabled):hover': {
        borderColor: COLORS.primary.light,
        boxShadow: '0px 1px 27px rgba(31, 44, 75, 0.1)',
      },
      '&$selected': {
        borderColor: COLORS.primary.default,
      },
      '&$disabled': {
        cursor: 'auto',
        borderColor: COLORS.gray.gray70,

        '& $icon rect:first-child': {
          fill: COLORS.gray.background,
        },
      },
    },
    selected: {},
    disabled: {},
    copyWrapper: {
      height: 100,
      marginBottom: theme.spacing(3),
      overflow: 'hidden',
    },
    title: {
      marginBottom: theme.spacing(0.5),
    },
    description: {
      color: COLORS.gray.gray30,
      display: '-webkit-box',
      WebkitBoxOrient: 'vertical',
      WebkitLineClamp: '3',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    icon: {
      width: 248,
      height: 143,
      marginBottom: theme.spacing(3),
    },
    footer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    comingSoonTag: {
      marginTop: theme.spacing(1.25),
      padding: theme.spacing(0.25, 0.5),
      backgroundColor: COLORS.neutral.darkGray,
      color: COLORS.neutral.white,
      borderRadius: theme.shape.borderRadiusSmall,
      marginRight: 'auto',
    },
    toolsIcons: {},
  }),
  { name: 'CardLarge' }
);
